import {Component,input,computed,ChangeDetectionStrategy} from '@angular/core';

export interface GraphqlMessage{
	message?:string;
	extensions?:{
		originalError?:{message?:string|string[]};
		response?:{message?:string|string[]};
		exception?:{message?:string|string[]};
	};
}
export interface MessageError{
	errors?:GraphqlMessage[];
	graphQLErrors?:GraphqlMessage[];
	error?:{message?:string};
	message?:string;
	result?:{errors?:GraphqlMessage[]};
}

/** Extract every human-readable message from a single GraphQL error entry. */
function graphQLErrorMessages(gqlError?:GraphqlMessage):string[]{
	const ext=gqlError?.extensions;
	const detail=ext?.originalError?.message??ext?.response?.message??ext?.exception?.message;
	if(detail!==undefined&&detail!==null) return (Array.isArray(detail)?detail:[detail]).map(String);
	return gqlError?.message?[String(gqlError.message)]:[];
}

/**
 * Resolve any surfaced api error into a single display string, collecting and
 * joining every message it carries (multiple GraphQL errors, multi-item
 * validation arrays, HTTP/native errors, plain strings). Returns '' for no
 * error, so templates can use it directly as an `@if` guard.
 */
export function resolveServerErrorMessage(error?:MessageError|string|null):string{
	if(error===null||error===undefined) return '';
	if(typeof error==='string') return error;

	const messages:string[]=[];

	// GraphQL errors: Apollo v4 `.errors`, legacy v3 `.graphQLErrors`,
	// and a ServerError/ServerParseError whose JSON body carries `result.errors`.
	const gqlErrors=error.errors??error.graphQLErrors??error.result?.errors;
	for(const e of gqlErrors??[]) messages.push(...graphQLErrorMessages(e));

	// HttpErrorResponse-like (`.error`) — object with a message, or a raw value.
	if(messages.length===0&&error.error!==undefined&&error.error!==null){
		messages.push(error.error.message!==undefined&&error.error.message!==null
			?String(error.error.message):String(error.error));
	}

	// Native Error / CombinedGraphQLErrors.message / ServerError.message.
	if(messages.length===0&&error.message) messages.push(String(error.message));

	return messages.length?`Error: ${messages.join(', ')}`:String(error);
}

@Component({
	selector:'app-form-message',
	imports:[],
	templateUrl:'./form-message.html',
	styleUrl:'./form-message.scss',
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class FormMessageComponent{
	serverError=input<MessageError|null>();
	serverResponse=input<string|null>();
	protected readonly displayError=computed<string>(()=>resolveServerErrorMessage(this.serverError()));
}
